export default class MetricNameRule {
    isSupport(filters, node) {
        if(filters.metric_name === 'is_data_leaving_eea' && node.data.attributes.is_data_leaving_eea ){
            return true
        }
        if(filters.metric_name === 'is_fingerprinting' && node.data.attributes.is_fingerprinting ){
            return true
        }
        if(filters.metric_name === 'is_local_storage' && node.data.attributes.is_local_storage ){
            return true
        }
        if(filters.metric_name === 'is_prior_to_consent' && node.data.attributes.is_prior_to_consent ){
            return true
        }
        return false
    }
    getColor() {
        return '#6565A9';
    }
    getTextColor(filters, node) {
        if (filters.vendor_name === node.data?.attributes.vendor_name){
            return '#2D2D2D';
        } else {
            return '#FFFFFF';
        }
    }
    getNodeBackgroundColor(filters, node) {
        if (filters.vendor_name === node.data?.attributes.vendor_name){
            return '#41ff6d';
        } else {
            return '#6565A9';
        }
    }
    getOpacity() {
        return 1;
    }
}
